import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'frNumber',
  standalone: true,
})
export class FrNumberPipe implements PipeTransform {
  private readonly formatter = new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  transform(value: number | string | null | undefined): string {
    if (value === null || value === undefined || value === '') return '0';
    const num = typeof value === 'string' ? Number(value) : value;
    if (isNaN(num as number)) return '0';
    return this.formatter.format(num as number);
  }
}